<template>
  <div class="fourth-Bar">
    <router-link
      :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
      v-for="(item, index) in list"
      :key="item.id"
      class="card"
      :style="`grid-area: card-${index + 1}`"
    >
      <div class="image-block">
        <ImageContainer
          :src="item.image.medium"
          :alt="item.title"
          :thumb="item.image.thumbnail"
          class="image"
        />
      </div>

      <div class="about">
        <span class="category">{{ item.sub_category.name }}</span>
        <h1 class="text">
          {{ item.title }}
        </h1>
        <h2 class="time">
          {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
        </h2>
      </div>
    </router-link>
  </div>
</template>
<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  name: "FourthBar",
  components: {
    ImageContainer
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>
<style lang="scss" scoped>
.fourth-Bar {
  padding-top: 5rem;
  width: 98%;
  position: relative;
  display: grid;
  grid-template-columns: 39% 1fr 1fr;
  grid-template-areas:
    "card-1 card-2 card-3"
    "card-1 card-4 card-5";
  grid-gap: 2.1em 2.5em;
  .card {
    position: relative;
    display: flex;
    .image-block {
      position: relative;
      .image {
        position: relative;
      }
    }
    .about {
      position: relative;
      font-style: normal;
      margin-left: 0.6rem;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .category {
        position: relative;
        font-family: Open Sans;
        font-style: normal;
        font-weight: 600;
        font-size: 2em;
        text-align: center;
        opacity: 0.7;
        text-transform: uppercase;
        margin-top: 0.4rem;
      }
      .text {
        position: relative;
        font-family: Roboto;
        font-weight: 500;
        font-size: 2.2em;
        display: -webkit-box;
        -webkit-line-clamp: var(--snup);
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .time {
        position: relative;
        font-family: Open Sans;
        font-weight: 300;
        font-size: 2em;
        opacity: 0.8;
      }
    }
    &:nth-child(1) {
      align-items: center;
      background: #fff;
      border-radius: 0 0 8.8em 0;
      color: #121212;
      .image-block {
        // max-width: 327px;
        margin: 2rem 0 2rem 1rem;
        width: 51%;
        .image {
          border-radius: 0 0 7.65em 0;
          aspect-ratio: 327/244;
        }
      }
      .about {
        width: 40%;
        line-height: 1.3;
        .text {
          margin: 0.3rem 0 0.5rem 0;
          --snup: 3;
        }
      }
    }
    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(4),
    &:nth-child(5) {
      color: #fff;
      z-index: 10;
      .image-block {
        width: 40%;
        // max-width: 181px;
        .image {
          aspect-ratio: 181/136;
        }
      }
      .about {
        line-height: 1.2;
        width: 60%;
        .text {
          --snup: 3;
        }
        .time {
          display: block;
          margin-top: auto;
        }
      }
    }
    &:nth-child(2),
    &:nth-child(5) {
      .image-block {
        .image {
          border-radius: 4.3em 0;
        }
      }
    }
    &:nth-child(3),
    &:nth-child(4) {
      .image-block {
        .image {
          border-radius: 0 4.3em;
        }
      }
    }
  }
}
@media screen and (max-width: 2900px) {
  .fourth-Bar {
    width: 95%;
    .card {
      .about {
        .category {
          font-size: 1.2em;
        }
        .text {
          font-size: 1.5em;
        }
        .time {
          font-size: 1.2em;
        }
      }
    }
  }
}
@media screen and (max-width: 1920px) {
  .fourth-Bar {
    width: 90%;
    .card {
      .about {
        .category {
          font-size: 1em;
        }
        .text {
          font-size: 1.19em;
        }
        .time {
          font-size: 0.88em;
        }
      }
      &:nth-child(1) {
        .image-block {
          max-width: 327px;
        }
      }
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5) {
        .image-block {
          max-width: 181px;
        }
      }
    }
  }
}

@media screen and (max-width: 998px) {
  .fourth-Bar {
    padding-top: 3rem;
    // background-color: #60657d;
    width: 100%;
    grid-template-columns: repeat(5, 1fr);
    grid-template-areas:
      "card-1 card-1 card-1 card-2 card-2"
      "card-1 card-1 card-1 card-2 card-2"
      "card-3 card-3 . card-2 card-2"
      "card-3 card-3 . card-4 card-4"
      "card-3 card-3 . card-4 card-4"
      "card-5 card-5 . card-4 card-4"
      "card-5 card-5 . . . "
      "card-5 card-5 . . . ";
    grid-gap: 2.25em 1.5em;
    .card {
      .about {
        align-items: center;
        text-align: center;
      }
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5) {
        flex-direction: column;
        .image-block {
          width: 100%;
          max-width: inherit;
          .image {
            aspect-ratio: 265/199;
          }
        }
        .about {
          width: 100%;
          margin: 0;
          .category {
            margin: 0.8rem 0 0 0;
          }
          .text {
            margin: 0.1rem 0 0.5rem 0;
          }
          .time {
            font-size: 0.9em;
          }
        }
      }
      &:nth-child(1) {
        border-radius: 0px 0px 6.09em 0px;
        .image-block {
          margin: 1rem 0 1rem 1rem;
        }
        .about {
          width: 40%;
          margin-right: 1.5rem;
          .text {
            --snup: 3;
          }
        }
      }
      &:nth-child(2),
      &:nth-child(4) {
        margin-right: 1.2rem;
        .image-block {
          .image {
            border-radius: 0 6.21em;
          }
        }
      }
      &:nth-child(3),
      &:nth-child(5) {
        margin-left: 1.2rem;
        .image-block {
          .image {
            border-radius: 6.21em 0;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 775px) {
  .fourth-Bar {
    .card {
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5) {
        max-width: 265px;
      }
    }
  }
}
@media screen and (max-width: 475px) {
  .fourth-Bar {
    padding-top: 1rem;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1.5em 0;
    grid-template-areas:
      "card-2 card-3"
      "card-2 card-3"
      "card-1 card-1"
      "card-1 card-1"
      "card-1 card-1"
      "card-4 card-5"
      "card-4 card-5";
    .card {
      .about {
        .category {
          font-size: 0.9em;
        }
        .text {
          font-size: 1em;
        }
        .time {
          font-size: 0.8em !important;
        }
      }
      &:nth-child(1) {
        width: 97%;
        flex-direction: row-reverse;
        border-radius: 0 0 0 4.71em;
        margin: 0 0 0 auto;
        .image-block {
          margin: 0.7rem 0.7rem 0.7rem 0;
          .image {
            border-radius: 0 0 0 3.93em;
          }
        }
        .about {
          margin-right: 1rem;
          margin-left: 1.5rem;
        }
      }
      &:nth-child(2) {
        margin: 0 0.75rem;
        // max-width: 148px;
        .image-block {
          .image {
            aspect-ratio: 148/111;
            border-radius: 0 3.46em;
          }
        }
      }
      &:nth-child(3) {
        margin: 0 0.75rem;
        .image-block {
          .image {
            aspect-ratio: 148/111;
            border-radius: 3.46em 0;
          }
        }
      }
      &:nth-child(4),
      &:nth-child(5) {
        align-self: center;
        justify-self: center;
        background: #56596f;
        border-radius: 4em;
        // max-width: 164px;
        margin: 0 0.75rem;
        .image-block {
          left: 50%;
          transform: translateX(-50%);
          width: 110%;
          max-width: 170px;

          .image {
            border-radius: 285.5px;
            aspect-ratio: 170/122;
          }
        }
        .about {
          width: 95%;
          padding-bottom: 1.5rem;
          .text {
            margin: 0.5rem 0;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 375px) {
  .fourth-Bar {
    .card {
      &:nth-child(2),
      &:nth-child(3) {
        justify-self: center;
        box-sizing: border-box;
        margin: 0;
        max-width: 148px;
      }
      &:nth-child(4),
      &:nth-child(5) {
        box-sizing: border-box;
        margin: 0;
        width: 90%;
        max-width: 164px;
      }
    }
  }
}
</style>
